export const TypeMovimentPesticides = {
  COMPRA: 'Compra',
  ENTRADA: 'Entrada',
  INVENTARIO_ENTRADA: 'Inventario Entrada',
  TRANSFERENCIA_ENTRADA: 'Transferência Entrada',
  DEVOLUCAO: 'Devolução',
  DEVOLUCAO_ENTRADA: 'Devolução Entrada',
  INVENTARIO_SAIDA: 'Inventario Saida',
  TRANSFERENCIA_SAIDA: 'Transferência Saida',
  VENDA: 'Venda',
}
